import React, { useEffect, useState } from "react";
import Slider from "react-rangeslider";

function SetReminder(props) {
  const {
    selectedBillReminderData,
    setAfterBillReminderProp,
    setBeforeBillReminderProp,
    billDetails
  } = props;

  const [afterBillReminder, setAfterBillReminder] = useState({
    isEnable: false,
    daysAfterBillGenerated: 0,
  });
  const [beforeBillReminder, setBeforeBillReminder] = useState({
    isEnable: false,
    daysBeforeDueDate: 0,
  });

  useEffect(() => {
    setAfterBillReminderProp(afterBillReminder);
  }, [afterBillReminder]);

  useEffect(() => {
    setBeforeBillReminderProp(beforeBillReminder);
  }, [beforeBillReminder]);

  useEffect(() => {
    let afterBillReminder = selectedBillReminderData?.find(
      (item) => item.eventSubTypeId === 1,
    );
    if (!afterBillReminder) {
      afterBillReminder = { isEnable: false, daysAfterBillGenerated: 0 };
    }
    setAfterBillReminder(afterBillReminder);

    let beforeBillReminder = selectedBillReminderData?.find(
      (item) => item.eventSubTypeId === 2,
    );
    if (!beforeBillReminder) {
      beforeBillReminder = { isEnable: false, daysBeforeDueDate: 0 };
    }
    setBeforeBillReminder(beforeBillReminder);
  }, [selectedBillReminderData]);

  return (
    <div>
      {/* <h6 className="font-weight-bold">Set Reminderfvsdf</h6> */}
      <div>
        {billDetails?.dueDate && <div className="row mb-2">
          <div
            className="col-md-4"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <input
              type="checkbox"
              checked={beforeBillReminder?.isEnable}
              name="daysBeforeDueCheckbox"
              style={{ width: "18px", height: "18px", marginRight: "8px" }}
              onChange={(event) => {
                setBeforeBillReminder({
                  ...beforeBillReminder,
                  isEnable: event.target.checked,
                });
              }}
            />
            <label htmlFor="check">Days Before Due Date</label>
          </div>
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-10">
                <Slider
                  min={0}
                  max={30}
                  value={Number(beforeBillReminder?.daysBeforeDueDate)}
                  onChange={(value) => {
                    setBeforeBillReminder({
                      ...beforeBillReminder,
                      daysBeforeDueDate: value,
                    });
                  }}
                />
              </div>
              <div className="col-md-2">
                <span className="rangesliderNumber">
                  {beforeBillReminder?.daysBeforeDueDate}
                </span>
              </div>
            </div>
          </div>
        </div>}
        {billDetails?.billDate && <div className="row mb-2">
          <div
            className="col-md-4"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <input
              type="checkbox"
              style={{ width: "18px", height: "18px", marginRight: "8px" }}
              value="1" //eventSubTypeId
              checked={afterBillReminder?.isEnable}
              name="daysAfterDueCheckbox"
              onChange={() => {
                setAfterBillReminder({
                  ...afterBillReminder,
                  isEnable: event.target.checked,
                });
              }}
            />
            <label htmlFor="check">Days After bill Generated</label>
          </div>
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-10">
                <Slider
                  min={0}
                  max={30}
                  value={Number(afterBillReminder?.daysAfterBillGenerated)}
                  onChange={(value) => {
                    setAfterBillReminder({
                      ...afterBillReminder,
                      daysAfterBillGenerated: value,
                    });
                  }}
                />

              </div>
              <div className="col-md-2">
                <span className="rangesliderNumber">
                  {afterBillReminder?.daysAfterBillGenerated}
                </span>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </div>
  );
}

export default SetReminder;
